/**
 * Definicja filtra SVG dla refrakcji szkła (feTurbulence + feDisplacementMap).
 *
 * Renderowana raz na stronie. Referencjonowana przez `url(#fitaily-liquid-glass)`
 * w `backdrop-filter` — obsługuje ją Chromium; przeglądarki, które nie
 * obsługują `url()` w `backdrop-filter` (Firefox, starsze Safari), zachowują
 * zwykły blur z klasy `.glass` / `.liquid-glass`.
 */
export function LiquidGlassDefs() {
  return (
    <svg aria-hidden="true" className="pointer-events-none absolute h-0 w-0" focusable="false">
      <defs>
        <filter id="fitaily-liquid-glass" x="-20%" y="-20%" width="140%" height="140%">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.008"
            numOctaves={2}
            seed="7"
            result="noise"
          />
          <feDisplacementMap
            in="SourceGraphic"
            in2="noise"
            scale="14"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
      </defs>
    </svg>
  );
}
